import '@babylonjs/core';
import '@babylonjs/gui';
import HavokPhysics, { HavokPhysicsWithBindings } from '@babylonjs/havok';
import '@babylonjs/inspector';
import '@babylonjs/loaders';
import { Game } from './Game';
import { GameConfig } from './GameConfig';

var game: Game;

async function getInitializedHavok() {
  return await HavokPhysics();
}

//start the game
window.addEventListener('DOMContentLoaded', async () => {
  const havoc: HavokPhysicsWithBindings = await getInitializedHavok();
  const config = new GameConfig();
  game = new Game(<HTMLCanvasElement>document.getElementById('renderCanvas'), havoc, config);
});
